import React from "react";

function Header() {
  return (
    <header id="main-header">
      <div id="main-title">Kim Young Jae - Portfolio</div>
      <div id="menu-button">
        <div className="button button-color1"></div>
        <div className="button button-color2"></div>
        <div className="button button-color3"></div>
      </div>
    </header>
  );
}

export default Header;
